import React, { useEffect, useState } from "react";
import { useDataLayerValue } from "../../data-layer";
import { ConvertView, simpleDateInYTDForm } from "../../helper/math";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import SortIcon from "@material-ui/icons/Sort";
import ShareIcon from "@material-ui/icons/Share";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import {
  SidebarIcon as SidebarOption,
  SmallCard,
} from "../../components/index";
import { Popular } from "../../dummy/poular";
import "./search.css";
import { Player } from "../../components";
import {
  Avatar,
  Button,
  FormGroup,
  FormControlLabel,
  Switch,
} from "@material-ui/core";

function Search() {
  const [{ video }, dispatch] = useDataLayerValue();
  const [test, setTest] = useState([]);

  useEffect(() => {
    setTest(Popular?.items.map((e) => e));
  }, []);
  useEffect(() => {
    if (video === undefined || video === null) {
      dispatch({
        type: "SET_VIDEO",
        video: JSON.parse(localStorage.getItem("watchVideo")),
      });
    }
  }, [video, dispatch]);
  console.log(test);
  const handleVideo = (video) => {
    dispatch({
      type: "SET_VIDEO",
      video: video,
    });
    localStorage.setItem("watchVideo", JSON.stringify(video));
  };



  return (
    <div className="searchPage">
      <div id="playerFocus" className="searchPage__left">
        <Player
          title={video?.snippet.title}
          id={typeof video?.id === "object" ? video?.id.videoId : video?.id}
        />
        <div className="searchPage__leftBottomHeading">
          <h3>{video?.snippet?.title}</h3>
        </div>
        <div className="searchPage__leftBottomStats">
          <div className="searchPage__leftBottomStatsLeft">
            <span>{ConvertView(video?.statistics?.viewCount)}</span> .
            <span>{simpleDateInYTDForm(video?.snippet.publishedAt)}</span>
          </div>
          <div className="sarchPage__leftBottomStatsRight">
            <SidebarOption
              Icon={ThumbUpIcon}
              title={ConvertView(video?.statistics?.likeCount || 4746)}
            />
            <SidebarOption
              Icon={ThumbDownIcon}
              title={ConvertView(video?.statistics?.dislikeCount || 6483)}
            />
            <SidebarOption Icon={ShareIcon} title="SHARE" />
            <SidebarOption Icon={PlaylistAddIcon} title="SAVE" />
            <SidebarOption Icon={MoreHorizIcon} title="" />
          </div>
        </div>
        <div className="serachPage__leftBottomUpload">
          <Avatar
            src="https://lh3.googleusercontent.com/ogw/ADGmqu_lsGkl9Cz7jMXGgZ49QBzCDXrPZo1wmI1PwBlW=s32-c-mo"
            className="searchPage__leftBottomImage"
          />
          <div className="searchpage__leftBottomName">
            <h4>{video?.snippet.channelTitle}</h4>
            <p>3.45M subscribers </p>
          </div>
          <Button variant="outlined">SUBSCRIBE</Button>
        </div>
        <p className="serachPage__leftBottomDescription">{video?.snippet.description}</p>
        <div className="searchPage__leftBottomDesc"></div>
        <div className="searchPage__leftBottomComment">
          <h4>{video?.statistics?.commentCount} Comments</h4>
          <SidebarOption Icon={SortIcon} title="Sort" />
        </div>
        <div className="serachPage__leftBottomUpload ">
          <Avatar
            src="https://lh3.googleusercontent.com/ogw/ADGmqu_lsGkl9Cz7jMXGgZ49QBzCDXrPZo1wmI1PwBlW=s32-c-mo"
            className="searchPage__leftBottomImage"
          />
          <div className="searchpage__leftBottomName">
            <input type="text" placeholder="Add a public comment..." />
          </div>
        </div>
      </div>

      <div className="searchPage__right">
        <div className="searchPage__rightTop">
          <h5>Up Next</h5>
          <FormGroup>
            <FormControlLabel
              className="searchPage__rightForm"
              control={<Switch />}
              label="AUTOPLAY"
            />
          </FormGroup>
        </div>
        {test.map((i) => (
          <SmallCard
            title={i?.snippet?.title}
            src={i?.snippet.thumbnails.medium.url}
            channelName={i?.snippet.channelTitle}
            detail={i}
            id={i?.id || i?.id.videoId}
            key={i.id || i.id.videoId}
            videoDetail={handleVideo}
            channelView={i?.statistics?.viewCount}
            channelTime={i?.snippet.publishedAt}
          />
        ))}
      </div>
    </div>
  );
}

export default Search;
